import { marketIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";

export const syncFiltersSchema = z.object({
  marketIds: z.array(marketIdFormat.schema).optional(),
  destinationCountryCodes: z.array(z.string()).optional(),
  variantIds: z.array(z.string()).optional(),
  hsCodePrefixes: z.array(z.string()).optional(),
  originCountries: z.array(z.string()).optional(),
  vendors: z.array(z.string()).optional(),
  tags: z.array(z.string()).optional(),
  productCategoryIds: z.array(z.string()).optional(),
});

export type SyncFilters = z.infer<typeof syncFiltersSchema>;
